import * as React from 'react';
import { useState } from 'react';
import { PopoverComponent } from './PopoverComponent';

export interface ActionPopoverProps {
	ariaLabel: string;
	children: React.ReactNode;
}

export const ActionPopover: React.FC<ActionPopoverProps> = ({ ariaLabel, children }) => {
	const [isOpen, setIsOpen] = useState(false);

	const [buttonElement, setButtonElement] = useState<HTMLButtonElement | null>(null);

	const closePopover = () => {
		setIsOpen(false);
	};

	return (
		<div style={{ position: 'relative' }}>
			<button
				ref={setButtonElement}
				type="button"
				className="btn-actions-dots"
				aria-label={ariaLabel}
				aria-haspopup="true"
				onClick={() => {
					setIsOpen(!isOpen);
				}}
			/>
			{isOpen && (
				<PopoverComponent closePopover={closePopover} triggerElement={buttonElement}>
					{children}
				</PopoverComponent>
			)}
		</div>
	);
};
